
import { defineComponent, ref, onMounted } from 'vue'
import LoadingButton from '@/views/components/LoadingButton.vue'
import ContentLayout from '@/views/layout/ContentLayout.vue'
import { keieiJohoRepositories } from '@/repositories/keiei-joho/keieiJohoRepositories'
import { callApiWrapper } from '@/views/callApiWrapper'
import ResponseResultAlert from '@/views/components/ResponseResultAlert.vue'
import { SonekiKeisanUiItem } from '@/views/keiei-joho/data'
import { UiItemsLogic } from '@/views/fuzoku-meisai/uiItemsLogic'
import { corporationTypeType, CorporationTypeType } from '@/views/corporation-info/types'
import SonekiKeisanSettingItem from '@/views/keiei-joho/soneki-keisan/SonekiKeisanSettingItem.vue'
const repository = keieiJohoRepositories.sonekiKeisanSetting

export default defineComponent({
  components: {
    SonekiKeisanSettingItem,
    ResponseResultAlert,
    ContentLayout,
    LoadingButton
  },
  setup () {
    const loading = ref(false)
    const isSucceedRequest = ref(false)
    const requestError = ref<string | null>(null)
    const hasError = ref<boolean>(false)
    const items = ref<SonekiKeisanUiItem[]>([])
    const corporationType = ref<CorporationTypeType>(corporationTypeType.Type1)

    onMounted(async () => {
      loading.value = true
      await callApiWrapper(requestError, async () => {
        const hasCorporationInfo = await repository.checkCorporationInfoExists()
        if (!hasCorporationInfo) {
          requestError.value = '法人情報が登録されていません。法人情報画面から登録してください。'
          loading.value = false
          hasError.value = true
          return
        }
        await refreshUiData()
      })
      loading.value = false
    })

    const onClickRegister = async () => {
      loading.value = true
      onDismissAlert()

      await callApiWrapper(requestError, async () => {
        const params = items.value.map(v => v.item)
        await repository.save(params)
        await refreshUiData()
        isSucceedRequest.value = true
      })
      loading.value = false
    }

    const onDismissAlert = () => {
      isSucceedRequest.value = false
      requestError.value = null
    }

    const onChangeInput = (item: SonekiKeisanUiItem) => UiItemsLogic.updateUiItem(items.value, item)

    const refreshUiData = async () => {
      const data = await repository.list()
      const sItems = data.items.map(value => ({ item: value, isValid: true }))
      if (data.corporationType === corporationTypeType.Type1) {
        items.value = sItems.filter(v => v.item.isRequiredSettingType1)
      } else {
        items.value = sItems.filter(v => v.item.isRequiredSettingType2To5)
      }
      corporationType.value = data.corporationType
    }

    return {
      loading,
      isSucceedRequest,
      requestError,
      items,
      corporationType,
      corporationTypeType,
      hasError,
      onClickRegister,
      onDismissAlert,
      onChangeInput
    }
  }
})
